import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqData = [
  {
    question: "What makes 1to10x different from other career development programs?",
    answer: "1to10x focuses on personalized career transformation with a practical learning approach. Our program combines live training, one-on-one mentorship, and real-world projects. Unlike generic courses, we tailor our approach to your specific career goals and current skill level."
  },
  {
    question: "How long does it take to see results from the program?",
    answer: "Most participants start seeing stronger clarity and skill growth within 3-6 months. However, the timeline varies based on your starting point, dedication, and career goals. Some participants use the full program duration to make strategic career pivots into entirely new industries."
  },
  {
    question: "Do I need prior experience in tech to benefit from 1to10x?",
    answer: "Not at all! Our program is designed for professionals from all backgrounds - whether you're in finance, consulting, healthcare, retail, or any other industry. We've successfully helped accountants become data scientists, teachers become product managers, and sales professionals become tech consultants. Your existing skills are valuable assets we'll help you leverage."
  },
  {
    question: "What kind of support do I get during the program?",
    answer: "You'll receive comprehensive support including weekly one-on-one mentorship sessions, access to live training workshops, resume and LinkedIn refinement, interview preparation, communication coaching, and ongoing learning guidance."
  },
  {
    question: "What kind of progress can I expect?",
    answer: "Progress depends on your starting point, commitment, and learning goals. During your strategy call, we'll discuss realistic milestones based on your specific situation."
  },
  {
    question: "What if I'm not satisfied with the program?",
    answer: "If you're not satisfied with your progress after following our program guidelines, we'll work with you to address your concerns. Our success is measured by your growth, and we're committed to supporting your career transformation goals."
  },
  {
    question: "How do I know if I'm ready for a career transformation?",
    answer: "If you're feeling stuck in your current role, underpaid for your skills, looking to break into a new industry, or simply want to accelerate your career growth, you're ready. Our FREE strategy call will help determine the best path forward for your unique situation."
  }
];

const FAQ = () => {
  return (
    <section className="py-20 px-4" style={{ backgroundColor: '#F1EFED' }}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Frequently Asked <span className="text-blue-600">Questions</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Everything you need to know about our career transformation programs
          </p>
        </div>

        {/* FAQ Accordion - Only show first 5 questions */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-0">
            {faqData.slice(0, 5).map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border-b border-gray-300 last:border-b-0"
            >
              <AccordionTrigger className="text-left text-gray-900 hover:text-gray-700 text-lg font-medium py-6 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 pb-6 pt-2 leading-relaxed text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
                      ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ; 
